import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import {base_url} from '../_common'
import {mockRequests, randomInt} from './_utils'
import middlewares from './_middlewares'

import * as items from './items'
import * as clients from './clients'
import * as accounts from './accounts'
import * as projects from './projects'
import * as warehouses from './warehouses'
import * as material_conditions from './material_conditions'
import * as packing_statuses from './packing_statuses'
import * as transaction_types from './transaction_types'
import * as transactions from './transactions'

// =============================================================
// mock axios requests

const path = `${base_url}/updates`;
let mockAdapter;

export function register_mock() {
  registered_sections['updates'] = true;
  mockAdapter = new MockAdapter(axios);

  mockRequests({
    mockAdapter,
    delay: ([method]) => method == 'get' ? 500 : 500,
    middlewares: middlewares.basic,
    requests: [
      ['get', path+'/counters', () => get_counters()],
      ['post', path, () => {
        // cause server error randomly every one in 30 requests
        if (randomInt(1, 30) == 1) {
          // eslint-disable-next-line
          // x = 0;
        }
      }],
    ]
  });

  // pass through other requests
  mockAdapter.onAny().passThrough();
}

// =============================================================
// data

// all update counters
const counters = {
  // users: 1,
  items: 1,
  clients: 1,
  accounts: 1,
  projects: 1,
  warehouses: 1,
  material_conditions: 1,
  packing_statuses: 1,
  transaction_types: 1,
  transactions: 1,
  transactions_type_list: 1,
};

// registered mock sections
export const registered_sections = {};

// =============================================================
// controller methods

const get_data = {
  users() {
    return [];
  },
  items() {
    return items.get_data();
  },
  clients() {
    return clients.get_data();
  },
  accounts() {
    return accounts.get_data();
  },
  projects() {
    return projects.get_data();
  },
  warehouses() {
    return warehouses.get_data();
  },
  material_conditions() {
    return material_conditions.get_data();
  },
  packing_statuses() {
    return packing_statuses.get_data();
  },
  transaction_types() {
    return transaction_types.get_data();
  },
  transactions() {
    return transactions.get_data();
  },
  transactions_type_list() {
    return transactions.get_transactions_type_list();
  },
}

export function increase_counter(section) {
  if (section in counters) {
    counters[section]++;
  }
}

export function get_counters() {
  const data = {_mock: true};

  Object.keys(counters).forEach(section => {
    if (registered_sections[section]) {
      data[section] = counters[section];
    }
  });
  
  return data;
}

export function get_updates(request_counters) {
  const data = {update_counters: {}, _mock: true};

  Object.keys(request_counters).forEach(section => {
    if (registered_sections[section] && section in counters && counters[section] > request_counters[section]) {
      if (section in get_data) {
        data[section] = get_data[section]();
        data.update_counters[section] = counters[section];
      } else {
        // eslint-disable-next-line
        console.warn(`[api-mock/updates] get_data[${section}] not found!`)
      }
    }
  });

  return data;
}


// updates data interceptor : used to merge real api updates with mock updates
export function update_interceptor(data, url) {
  // request processed by mock : do nothing except deleting _mock flag
  if (data._mock) {
    delete data._mock;
  // requesting updates : merge with mock
  } else if (url == 'updates') {
    const mock_counters = Object.keys(registered_sections).reduce((o, section) => {
      o[section] = 0;
      return o;
    }, {});

    const mock_updates = get_updates(mock_counters);
    delete mock_updates._mock;

    data = {
      ...data,
      ...mock_updates,
      update_counters: {
        ...data.update_counters,
        ...mock_updates.update_counters,
      }
    };
  // requesting counters : merge with mock
  } else if (url == 'updates/counters') {
    const mock_counters = get_counters();
    delete mock_counters._mock;

    data = {
      ...data,
      ...mock_counters
    };
  // other actions : delete sections registred in mocks
  } else {
    data = {...data, update_counters: {...data.update_counters}};
    Object.keys(registered_sections).forEach(section => {
      delete data[section];
      delete data.update_counters[section];
    });
  }

  return data;
}
